<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import copyToClipBoard from '@utils/copy-to-clipboard'
import SocialShare from '@components/social-share'
import { useStore } from '@composables/use-store'
import { useMessages } from '@composables/use-messages'

const props = defineProps({
    playlist: {
        type: Object,
        default: () => {},
    },
})

const store = useStore()
const router = useRouter()
const getMessageText = useMessages()

const routeName = computed(() => (props.playlist.type === 'chart' ? 'browse/charts' : 'browse/playlists'))

const url = computed(() => {
    const { protocol, hostname, port } = window.location
    const href = router.resolve({ name: routeName.value, params: { id: props.playlist.id } }).href
    return `${protocol}//${hostname}${port ? ':' + port : ''}${href}`
})

function copyLinkToClipBoard() {
    copyToClipBoard(url.value)
    store.dispatch('appearance/handleNotification', {
        message: getMessageText('LINK_COPIED_CLIPBOARD'),
        type: 'success',
    })
}
</script>

<template>
    <ul class="playlist-options">
        <li
            class="playlist-options-item"
            @click="
                router.push({
                    name: `${routeName}`,
                    params: { id: playlist.id },
                })
            "
        >
            <BaseButton
                icon="eye"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp;
                <span>View {{ playlist.type === 'chart' ? 'Chart' : 'Playlist' }}</span></BaseButton>
        </li>
        <h6 class="share-title">Share</h6>
        <div class="separator" />
        <li class="playlist-options-item">
            <BaseButton
                icon="facebook"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    type="facebook"
                />
            </BaseButton>
        </li>
        <li class="playlist-options-item">
            <BaseButton
                icon="twitter"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    :custom-text="`${playlist.revisions_title} on @friskyradio #feelinfrisky`"
                    type="twitter"
                />
            </BaseButton>
        </li>
        <li
            class="playlist-options-item"
            @click="copyLinkToClipBoard"
        >
            <BaseButton
                icon="link"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp; Copy {{ playlist.type === 'chart' ? 'Chart' : 'Playlist' }} link
            </BaseButton>
        </li>
    </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.playlist-options {
    padding: 0;
    margin: 0;
    list-style: none;

    &-item {
        display: flex;
        align-items: center;
        height: 44px;
        padding: 0 $s-m;
    }
}

.separator {
    position: relative;
    display: block;
    width: 100%;
    height: 1px;
    background: $c-mine-shaft;
}

.share-title {
    @extend %contentTitleM;

    margin: $s-s 0 $s-s $s-xl;
}
</style>
